import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import { Translate } from "react-localize-redux";

class ModalRedeem extends Component {
  constructor(props) {
    super(props);

    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleConfirmClick = this.handleConfirmClick.bind(this);
    this.handleAfterOpenModal = this.handleAfterOpenModal.bind(this);
  }

  handleCancelClick() {
    const { onCancelClick } = this.props;
    onCancelClick && onCancelClick();
  }

  handleConfirmClick() {
    const { onConfirmClick } = this.props;
    onConfirmClick && onConfirmClick();
  }

  handleAfterOpenModal() {
    const { onAfterOpenModal } = this.props;
    onAfterOpenModal && onAfterOpenModal();
  }

  render() {
    const {
      showModal,
      title,
      message,
      isOpen,
      confirmButtonText,
      cancelButtonText,
      ...props
    } = this.props;
    return (
      <Translate>
        {(translate, activeLanguage) => (
          <ReactModal
            isOpen={isOpen}
            onAfterOpen={this.handleAfterOpenModal}
            onRequestClose={this.handleCancelClick}
            {...props}
          >
            <div className="modal-header">
              {/* <h3 className="modal-header-title">
                                {!title && translate("modal.title._message")}
                            </h3> */}
              <div className="modal-close-mark">
                <button
                  style={{ paddingLeft: 50, paddingTop: 10 }}
                  className="btn-close-mark"
                  onClick={this.handleCancelClick}
                />
              </div>
            </div>
            <div className="modal-body pt-0">{this.props.children}</div>
          </ReactModal>
        )}
      </Translate>
    );
  }
}

ModalRedeem.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  onAfterOpenModal: PropTypes.func
};

export default ModalRedeem;



// WEBPACK FOOTER //
// ./src/views/components/modal/ModalRedeem.js